module.exports = __webpack_public_path__ + "static/media/settingsIcon.a9fb9fcc.svg";